import { Trans, t } from "@web-monorepo/i18n/macro";
import { DDSDisplayText, DDSHeadlineText } from "@web-monorepo/dds";
import ToolkitModal from "components/ToolkitModal";
import { useState } from "react";
import styles from "./CustomTimeModal.module.css";
import TimeInput from "./TimeInput";

type CustomTimeModalProps = {
  startTimer: (input: number) => void;
  goBack: VoidFunction;
};

type SelectedField = "minutes" | "seconds";

export default function CustomTimeModal({ startTimer, goBack }: CustomTimeModalProps) {
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [selected, setSelected] = useState<SelectedField>("minutes");

  return (
    <ToolkitModal
      primaryButton={{
        text: t`Start`,
        "data-name": "toolkit.timer.start",
        onClick: () => startTimer(Number(minutes) * 60 + Number(seconds)),
      }}
      secondaryButton={{
        text: t`Cancel`,
        "data-name": "toolkit.timer.cancel",
        onClick: goBack,
      }}
    >
      <DDSHeadlineText as="h2" level="md">
        <Trans>New timer</Trans>
      </DDSHeadlineText>
      <div className={styles.row}>
        <TimeInput
          value={minutes}
          selected={selected === "minutes"}
          onChange={setMinutes}
          onFocus={() => setSelected("minutes")}
        />
        <DDSDisplayText>:</DDSDisplayText>
        <TimeInput
          value={seconds}
          selected={selected === "seconds"}
          onChange={setSeconds}
          onFocus={() => setSelected("seconds")}
        />
      </div>
    </ToolkitModal>
  );
}
